import {
  GridAlignment,
  GridColDef,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import React, { useContext, useEffect, useState } from "react";
import {
  BrowserControlKeys,
  TableHeaderProps,
} from "../../../../../utils/types";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import {
  HEADER_TEXT_ALIGN,
  MARKS_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../styles/Variables";
import {
  LicenseTypes,
  Operation,
  PageFor,
  TableHeaders,
} from "../../../../../utils/Enum.types";
import Edit from "../../../../../images/EditProfile.svg";
import Delete from "../../../../../images/Delete.svg";
import { Title } from "../../../../../stories/Title/Title";
import Input from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { useNavigate } from "react-router-dom";

import {
  AddModalStyles,
  EditModalStyles,
} from "../../../../../styles/CustomModalStyles";
import View from "./view/Index";
import EditModal from "./edit/Index";
import Close from "../../../../../images/Close.svg";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GetSuppliers } from "./queries/queries";
import {
  AtsAcLdgrEdge,
  AtsAcLdgrOrderField,
  DeleteSupplierByIdResult,
  DeleteSupplierByIdVars,
  GetSuppliersResult,
  GetSuppliersVars,
  LdgrQueryType,
} from "./queries/types";
import { AppContext } from "../../../../../context/context";
import { payloadTypes } from "../../../../../context/reducer";
import { modalOpertaionFlag } from "../../../customer/Index";
import {
  CustomModal,
  getModifiedScrollHeight,
} from "../../../../../utils/UtilFunctions";
import {
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  emptyMessage,
} from "../../../../../utils/constants";

import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import { DeleteSupplier } from "./queries/mutations";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import LoadingModal from "../../../../pages/LoadingModal";
import Navbar from "../../../../common/layout/Navbar";
import { useHotKey } from "../../../../../utils/hotKeys";
import { SpecialKeys } from "../../../../../utils/Enum.keys";
import useLabels from "../../../../../customHooks/useLabels";
import { useBrowserControl } from "../../../../../utils/browserControls";
// const Data = [
//   {
//     supplier: "Praveen Technologies",
//     gst: "89653254",
//     city: "bangalore",
//     state: "karnataka",
//     proficiency: "computer sales",
//     mobile_no: 98653254785,
//     c_person: "-",
//   },
// ];
interface Props {
  pageType: PageFor;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  project?: boolean;
}
const Supplier = ({ pageType, setModalFlag, project }: Props) => {
  const { Masters_Table } = useAssetTableJson();
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [suppliers, setSuppliers] = useState<AtsAcLdgrEdge[]>([]);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);

 

  const { state, dispatch } = useContext(AppContext);

  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();

  const navigate = useNavigate();

  const [searchData, setSearchData] = useState("");
  const [message, setMessage] = useState(emptyMessage);

  const [GetSupplierDetails, { data, loading, fetchMore }] = useLazyQuery<
    GetSuppliersResult,
    GetSuppliersVars
  >(GetSuppliers);

  const [DeleteStockSupplier, { loading: deletionLoading }] = useMutation<
    DeleteSupplierByIdResult,
    DeleteSupplierByIdVars
  >(DeleteSupplier, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const dynamicHeaders: TableHeaderProps[] = Masters_Table.Masters.Supplier.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      cellClassName: header.cellClassName,
      hideable: header.hideable,
    })
  );

  const columns: GridColDef[] = [
    ...dynamicHeaders,
    {
      field: "actions",
      headerAlign: HEADER_TEXT_ALIGN,
      align: MARKS_TEXT_ALIGN,
      headerName: TableHeaders.ACTION,
      renderCell: (params) => {
        return (
          <>
            <img
              src={Edit}
              alt=""
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_SUPPLIER_ID,
                  payload: {
                    supplierId: params.row.supplier_id,
                  },
                });
                setEditModal(true);
              }}
            />
            <img
              src={Delete}
              alt=""
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_SUPPLIER_ID,
                  payload: {
                    supplierId: params.row.supplier_id,
                  },
                });
                setDeleteModal(!deleteModal);
              }}
            />
          </>
        );
      },
    },
  ];

  const HandleDelete = () => {
    if (customer_id) {
      setDeleteModal(!deleteModal);
      DeleteStockSupplier({
        variables: {
          
          customer_id,
          supplier_ids: [state.supplierId],
          user_details,
        },
        refetchQueries: [
          {
            query: GetSuppliers,
            variables: {
              after: null,
              customer_id,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsAcLdgrOrderField.CREATED_AT,
              },
              
              name: searchData,
              input: {
                query_type: LdgrQueryType.ALL,
                itemID: 0,
              },
            },
          },
        ],
      }).then(({ data }) => {
        if (data && data.DeleteSupplier) {
          setMessage({
            flag: true,
            message: `${ledgerLabel} Deleted Sucessfully`,
            operation: Operation.DELETE,
          });
        }
      });
    }
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetSuppliers.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = suppliers.find(
            (sub) => sub.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setSuppliers(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            desc: node.desc,
            gstNo: node.supplier_details.gstNo,
            city: node.supplier_details.city,
            state: node.supplier_details.state,
            proficiency: node.supplier_details.proficiency,
            phone: node.supplier_details.phone,
            contactPerson: node.supplier_details.contactPerson,
            supplier_id: node.id,
          }))
        );
      } else {
        setSuppliers(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            desc: node.desc,
            gstNo: node.supplier_details.gstNo,
            city: node.supplier_details.city,
            state: node.supplier_details.state,
            proficiency: node.supplier_details.proficiency,
            phone: node.supplier_details.phone,
            contactPerson: node.supplier_details.contactPerson,
            supplier_id: node.id,
          }))
        );
      }
      setEndCursor(data.GetSuppliers.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetSuppliers.edges;
              const pageInfo = fetchMoreResult.GetSuppliers.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetSuppliers.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetSuppliers: {
                  edges: [...suppliers, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetSuppliers.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    if (customer_id) {
      GetSupplierDetails({
        variables: {
          after: null,
          customer_id,
          first: ROWS_PER_PAGE,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsAcLdgrOrderField.CREATED_AT,
          },
          
          name: searchData,
          input: {
            query_type: LdgrQueryType.ALL,
            itemID: 0,
            tableLevel: undefined,
          },
        },
      });
    }
  }, [customer_id, GetSuppliers, searchData]);

  useHotKey({
    handleFunc: () => {
      navigate(`/${customer_id}/company/masters/supplier/0/basicdetails`);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });

  const { ledgerLabel } = useLabels();

  return (
    <>
      {pageType === PageFor.GENERAL && (
        <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />
      )}
      <div className="supplier__title">
        <Title>{ledgerLabel}</Title>
        {pageType === PageFor.MODAL && (
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        )}
      </div>

      <div
        className={`supplier${pageType === PageFor.GENERAL ? "" : "--modal"}`}
      >
        <div className="supplier__select row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setSearchData(e.target.value);
              }}
            />
          </div>
          {pageType === PageFor.GENERAL && (
            <div className="col flex-end">
              <Button
                mode="addnew"
                autoFocus
                onClick={() =>
                  navigate(
                    `/${customer_id}/company/masters/supplier/0/basicdetails`
                  )
                }
              />
            </div>
          )}
        </div>
        <div className="supplier__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            onCellClick={(params) => {
              if (params.field === "desc") {
                dispatch({
                  type: payloadTypes.SET_SUPPLIER_ID,
                  payload: {
                    supplierId: params.row.supplier_id,
                  },
                });
                if (project) {
                  setModalFlag(false);
                } else {
                  setViewModal(!viewModal);
                }
              }
            }}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
        {pageType === PageFor.GENERAL ? (
          <Button mode="back" onClick={() => navigate(-1)} />
        ) : (
          <Button mode="cancel" onClick={() => setModalFlag(false)} />
        )}
      </div>
      <CustomModal
        isOpen={viewModal}
        onRequestClose={() => setViewModal(!viewModal)}
        contentComponent={<View setModalFlag={setViewModal} />}
        style={AddModalStyles}
      />

      <CustomModal
        isOpen={editModal}
        onRequestClose={() => setEditModal(!editModal)}
        style={EditModalStyles}
        contentComponent={<EditModal setModalFlag={setEditModal} />}
      />

      <DeleteModal
        id={state.supplierId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={HandleDelete}
      />
      <LoadingModal flag={(!searchData && loading) || deletionLoading} />
    </>
  );
};

export default Supplier;
